import { connect } from 'react-redux';

import { IA_KEY } from 'helpers/ia-logic';
import { selectActiveVenue, selectIaLogic } from 'selectors/general';

import { selectOpportunities, selectOpportunitiesByType } from './Opportunities.selectors';
import {
  actOnOpportunities as actOnOpportunitiesAction,
  actOnOpportunity as actOnOpportunityAction,
  actOnSmartSpotOpportunities as actOnSmartSpotOpportunitiesAction,
} from './Opportunities.saga';
import Opportunities from './Opportunities';

export const mapStateToProps = state => {
  const { venueId, isManualStudio, isMsInventoryVenue } = selectActiveVenue(state);
  const { featureIsSupported } = selectIaLogic(state, IA_KEY.OPPORTUNITIES, venueId);
  const { data: opportunities, isLoaded, error } = selectOpportunities(state);
  const { classOpportunities, smartSpotOpportunities } = selectOpportunitiesByType(state);

  // Filter spot opportunities from already-sorted opportunities (maintains chronological order)
  const spotOpportunities = opportunities.filter(opp => !opp.classDisabled);

  return {
    opportunities,
    classOpportunities,
    spotOpportunities,
    smartSpotOpportunities,
    featureIsSupported,
    hasSpotChangeOpportunities: spotOpportunities.length > 0,
    hasError: Boolean(error),
    isLoaded,
    isManualStudio,
    isMsInventoryVenue,
    venueId,
  };
};

const mapDispatchToProps = {
  actOnOpportunities: actOnOpportunitiesAction,
  actOnOpportunity: actOnOpportunityAction,
  actOnSmartSpotOpportunities: actOnSmartSpotOpportunitiesAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { venueId, opportunities } = stateProps;
  const { actOnOpportunities, actOnOpportunity, actOnSmartSpotOpportunities } = dispatchProps;

  return {
    ...stateProps,
    actOnOpportunities: actOnOpportunities.bind(null, venueId, opportunities),
    actOnOpportunity: actOnOpportunity.bind(null, venueId, opportunities),
    actOnSmartSpotOpportunities: actOnSmartSpotOpportunities.bind(null, venueId),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Opportunities);
